<div class="outside-box">
  @if(!production) {
  <div class="dev-banner">
    <p><strong>Development Mode</strong></p>
  </div>
  }
  <div class="inside-box">
    <mat-card class="login-card">
      <div class="logo-container">
        <img src="/logo.png" alt="Company Logo" class="login-logo" />
      </div>

      <mat-card-header>
        <mat-card-title>Sign In</mat-card-title>
        <mat-card-subtitle>
          Please enter your username and password to sign in.
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Username</mat-label>
            <input matInput type="text" formControlName="username" required autocomplete="off">
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Password</mat-label>
            <input matInput type="password" formControlName="password" required autocomplete="off">

          </mat-form-field>

          <div class="form-actions">
            <button mat-flat-button color="primary" type="submit" class="submit-button"
              [disabled]="loginForm.invalid || busyService.loading">
              Sign In
            </button>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="additional-actions">
        <a routerLink="/new-account-setup" class="action-link">Setup New Account</a>
        <a routerLink="/reset-password-request" class="action-link">Forgot Password?</a>
      </mat-card-actions>

      <div class="footer-logo-container">
        <img src="/logoImage.png" alt="MitreX Logo" class="footer-logo" />
        <a href="https://www.mitrexglobal.com" class="credit-text" target="_blank" rel="noopener noreferrer">Developed
          by MitreX Global</a>
      </div>
    </mat-card>
  </div>
</div>